module.exports = __webpack_public_path__ + "img/finish.57224a42.png";